import styled from '@emotion/styled';

const Wrapper = styled.div`
  table {
    td:last-of-type {
      font-size: 1.4rem;
    }
  }
`;

const FlagBox = styled.p`
  display: flex;
  align-items: center;
  gap: 1rem;

  img {
    display: block;
    width: 2rem;
    border: .1rem solid ${(props) => props.theme.color.gray};
  }
  span {
    white-space: break-spaces;
  }
`;

export {
  Wrapper,
  FlagBox
};
